import type { OptionContract } from '../../types/finance'

interface Props {
  contracts: OptionContract[]
  type: 'calls' | 'puts'
  underlyingPrice: number
}

export default function OptionsTable({ contracts, type, underlyingPrice }: Props) {
  const isCalls = type === 'calls'

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-slate-200 dark:border-slate-700">
            <th className="text-left text-slate-500 dark:text-slate-400 font-medium px-3 py-2">Strike</th>
            <th className="text-right text-slate-500 dark:text-slate-400 font-medium px-3 py-2">Last</th>
            <th className="text-right text-slate-500 dark:text-slate-400 font-medium px-3 py-2">Bid</th>
            <th className="text-right text-slate-500 dark:text-slate-400 font-medium px-3 py-2">Ask</th>
            <th className="text-right text-slate-500 dark:text-slate-400 font-medium px-3 py-2">Volume</th>
            <th className="text-right text-slate-500 dark:text-slate-400 font-medium px-3 py-2">Open Int</th>
            <th className="text-right text-slate-500 dark:text-slate-400 font-medium px-3 py-2">IV</th>
          </tr>
        </thead>
        <tbody>
          {contracts.map((contract) => {
            const isATM = Math.abs(contract.strike - underlyingPrice) < (underlyingPrice * 0.015)
            const itm = contract.inTheMoney
            return (
              <tr
                key={contract.contractSymbol}
                className={`border-b border-slate-200/50 dark:border-slate-700/50 hover:bg-slate-200/30 dark:hover:bg-slate-700/30 transition-colors ${
                  isATM ? 'bg-blue-500/5 border-blue-500/20' : ''
                } ${itm ? (isCalls ? 'bg-emerald-500/5' : 'bg-red-500/5') : ''}`}
              >
                <td className="px-3 py-2">
                  <span className={`font-medium ${isATM ? 'text-blue-600 dark:text-blue-400' : 'text-slate-900 dark:text-white'}`}>
                    ${contract.strike.toFixed(2)}
                  </span>
                  {isATM && <span className="ml-1.5 text-[10px] text-blue-600 dark:text-blue-400 font-medium">ATM</span>}
                </td>
                <td className="text-right px-3 py-2 text-slate-600 dark:text-slate-300">${contract.lastPrice.toFixed(2)}</td>
                <td className="text-right px-3 py-2 text-slate-600 dark:text-slate-300">${contract.bid.toFixed(2)}</td>
                <td className="text-right px-3 py-2 text-slate-600 dark:text-slate-300">${contract.ask.toFixed(2)}</td>
                <td className="text-right px-3 py-2 text-slate-500 dark:text-slate-400">{contract.volume.toLocaleString()}</td>
                <td className="text-right px-3 py-2 text-slate-500 dark:text-slate-400">{contract.openInterest.toLocaleString()}</td>
                <td className="text-right px-3 py-2">
                  <span className={`${contract.impliedVolatility > 0.4 ? 'text-amber-600 dark:text-amber-400' : 'text-slate-600 dark:text-slate-300'}`}>
                    {(contract.impliedVolatility * 100).toFixed(1)}%
                  </span>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
